import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.array.index-of.js";
import "core-js/modules/es6.symbol.js";
import React__default, { createElement } from 'react';
import cn from 'classnames';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var styles = {
  "button": "Button-module_button__1viMV",
  "primary": "Button-module_primary__2WEHw Button-module_button__1viMV",
  "secondary": "Button-module_secondary__2TgRb Button-module_button__1viMV",
  "tertiary": "Button-module_tertiary__3x_-S Button-module_button__1viMV",
  "success": "Button-module_success__Ew85H Button-module_button__1viMV",
  "action": "Button-module_action__3w-dm Button-module_button__1viMV"
};
var Button = React__default.forwardRef(function (_a, ref) {
  var className = _a.className,
      _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      buttonProps = __rest(_a, ["className", "variant"]);

  return React__default.createElement("button", _assign({
    ref: ref,
    className: cn(styles[variant], className)
  }, buttonProps));
});

var _path;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SvgPhone(props) {
  return (/*#__PURE__*/createElement("svg", _extends({
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em"
    }, props), _path || (_path = /*#__PURE__*/createElement("path", {
      d: "M19.241 15.048l-3.178-3.196a1.233 1.233 0 00-1.745-.002l-2.824 2.822-6.163-6.16 2.827-2.825c.481-.48.482-1.26.001-1.742L4.98.76a1.233 1.233 0 00-1.744 0L.405 3.59.4 3.585C.4 12.43 7.574 19.6 16.424 19.6l2.815-2.813a1.23 1.23 0 00.002-1.739z"
    })))
  );
}

var _path$1, _path2, _defs;

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function SvgEnvelope(props) {
  return (/*#__PURE__*/createElement("svg", _extends$1({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), _path$1 || (_path$1 = /*#__PURE__*/createElement("path", {
      d: "M21.6 7.8v9.454c0 1.081-.846 1.946-1.904 1.946H4.304c-1.058 0-1.904-.865-1.904-1.946V7.8l9.309 6.378c.212.108.423.108.582 0L21.6 7.8z"
    })), _path2 || (_path2 = /*#__PURE__*/createElement("path", {
      d: "M4.213 4.8h15.52c.854 0 1.6.637 1.867 1.448L12 12.6 2.4 6.248c.213-.81.96-1.448 1.813-1.448z"
    })), _defs || (_defs = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
      id: "envelope_svg__clip0"
    }, /*#__PURE__*/createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    })))))
  );
}

function getIconSvg(name) {
  switch (name) {
    case 'phone':
      return SvgPhone;

    case 'envelope':
      return SvgEnvelope;
  }
}

var Icon = function Icon(_a) {
  var icon = _a.icon,
      iconProps = __rest(_a, ["icon"]);

  var Icon = getIconSvg(icon);
  return React__default.createElement(Icon, _assign({}, iconProps));
};

var styles$1 = {
  "input": "Input-module_input__3tJne"
};
var Input = React__default.forwardRef(function (_a, ref) {
  var className = _a.className,
      inputProps = __rest(_a, ["className"]);

  return React__default.createElement("input", _assign({
    ref: ref,
    className: cn(styles$1.input, className)
  }, inputProps));
});
var styles$2 = {
  "label": "Label-module_label__1TN2q"
};
var Label = React__default.forwardRef(function (_a, ref) {
  var className = _a.className,
      labelProps = __rest(_a, ["className"]);

  return React__default.createElement("label", _assign({
    ref: ref,
    className: cn(styles$2.label, className)
  }, labelProps));
});
var styles$3 = {
  "select": "Select-module_select__2sRKy"
};
var Select = React__default.forwardRef(function (_a, ref) {
  var className = _a.className,
      children = _a.children,
      selectProps = __rest(_a, ["className", "children"]);

  return React__default.createElement("select", _assign({
    ref: ref,
    className: cn(styles$3.select, className)
  }, selectProps), children);
});

var ErrorIcon = function ErrorIcon(_a) {
  var className = _a.className;
  return React__default.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React__default.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "8",
    fill: "white"
  }), React__default.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 12C7.4 12 7 11.6 7 11C7 10.4 7.4 10 8 10C8.6 10 9 10.4 9 11C9 11.6 8.6 12 8 12ZM9 9H7V4H9V9Z",
    fill: "#FA2519"
  }));
};

var styles$4 = {
  "container": "FormErrorMessage-module_container__2XkRH",
  "icon": "FormErrorMessage-module_icon__1krsD",
  "message": "FormErrorMessage-module_message__oG3p4"
};

var FormErrorMessage = function FormErrorMessage(_a) {
  var className = _a.className,
      message = _a.message;
  return React__default.createElement("div", {
    className: cn(styles$4.container, className)
  }, React__default.createElement(ErrorIcon, {
    className: styles$4.icon
  }), React__default.createElement("p", {
    className: styles$4.message
  }, message));
};

export { Button, FormErrorMessage, Icon, Input, Label, Select };